import ReactStrapTable from 'components/reactStrapTable';
import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { dateFormate, currencyFormat, cellRendererCheck } from 'utils/columns';
import CancleIcon from 'assets/icon/icon-icon-options-not-eligible.svg';
import SaveIcon from 'assets/icon/icon-icon-options-order-complete.svg';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import CancleHoverIcon from 'assets/icon/icon-icon-options-not-eligible-hover.svg';
import SaveHoverIcon from 'assets/icon/icon-icon-options-order-complete-hover.svg';
import { Formik } from 'formik';
import ReactSelect from 'react-select';
import { toast } from 'react-toastify';
import useAxios from 'hooks/useAxios';
import { ModuleAccess } from 'utils/moduleaccess';
import save from "assets/icon/save.svg";
import cancel from "assets/icon/cancel.svg";
import plus from "assets/icon/plus-icon.svg";
import { cloneDeep } from 'lodash';
import useContextService from 'hooks/useContextService';

let tableDataBackup = []
let rowForEdit = {};
let updatedFields = {};

const PatientTypeTable = (props) => {
    debugger
    const {
        manvalConfigedit,
        manvalConfig,
        data,
        totalSize,
        filters,
        orgId,
        onPageChange,
        fetchAccumulatorTable,
        toggleSider,
        collapseSider,
        manvalPharmacy,
        onSearchColumnFilters = () => '',
        // handleSort = () => "",
    } = props;
    const {
        states: { configPatientType },
        setStates,
    } = useContextService();
    const { search, } = configPatientType;
    //tableDataBackup = data
    const API = useAxios()
    let PatientType = [
        {
            "id": "IN",
            "label": "IN"
        },
        {
            "id": "OUT",
            "label": "OUT"
        }
    ]
    const tenantID = orgId?.tenantID
    const [colFilters, setColFilters] = useState({});
    const [tableData, setTableData] = useState(tableDataBackup);
    const [loading, setLoading] = useState(false)
    const [showDetails, setShowDetails] = useState(false)
    const [hasTouched, setTouched] = useState('');
    const [modal, setModal] = useState(false);
    const [active, setActive] = useState(true)
    const [columnFilters, setColumnFilters] = useState([]);
    const [originalData, setOriginalData] = useState({});
    const [ishiddenflag, setIshiddenflag] = useState(false);
    const [state, updateState] = useState({
        tableData: [],
        backUpData: [],
        filters: filters,
    });

useEffect(()=>{
    setModal(false);
},[orgId])

    useEffect(() => {
        setState({ tableData: data, backUpData: data });
    }, [data]);

    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

    useEffect(() => {
        filters.pageSize=10;
        setState({ filters: filters });
    }, [filters]);

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };
    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        debugger
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
             filters.currentPage=filter.currentPage;
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };
    const toggle = () => setModal(!modal);
    useEffect(() => {
        setTableData(data);
        tableDataBackup = data;
    }, [data]);

    const renderCheckBox = (rowData, col) => {
        return (
            <Input
                className="text-primary p-0 text-decoration-none"
                type="checkbox"
                checked={rowData.inactiveFlag === "N"}
                disabled={!rowData.isEdit}
                title="Active"
            />
        );
    };
    const hasPermission = (code) => {
        return ModuleAccess("CON", code);
    }
    const renderEditButton = (rowData) => {
        if (hasPermission('ED'))
            return <Button
                className='text-primary p-0 text-decoration-none'
                color='link'
                onClick={() => {
                    setIshiddenflag(false);
                    editRow(rowData);
                }}
                title='Edit Patient Details'
            >
                <HoverImage src={EditIcon}
                    hoverSrc={EditHoverIcon}
                    alt='' />
            </Button>
    }
    const cellRenderEdit = (rowData) => {
        if (hasPermission('ED'))
            if (rowData.isEdit) {
                return (
                    <div className="d-flex align-items-center">
                        <Button
                            className="text-primary p-0 text-decoration-none"
                            color="link"
                            onClick={toggle}
                            hidden={!ishiddenflag}
                        >
                            <HoverImage
                                key="SaveIcon"
                                src={SaveIcon}
                                hoverSrc={SaveHoverIcon}
                                alt=""
                            />
                        </Button>
                        <Button
                            className="text-primary p-0 text-decoration-none"
                            color="link"
                            onClick={() => editRow(rowData, false)}
                        >
                            <HoverImage
                                key="CancelIcon"
                                src={CancleIcon}
                                hoverSrc={CancleHoverIcon}
                                alt=""
                            />
                        </Button>
                    </div>
                );
            } else {
                return (
                    <div className="d-flex align-items-center">
                        {renderEditButton(rowData)}
                    </div>
                );
            }
    };

    const editRow = (rowData, isEdit = true) => {

        if (isEdit == false) {
            setIshiddenflag(false);
        }
        let tempData = [...data];
        if (isEdit) {
            setOriginalData({ ...rowData });
        }
        tempData = tempData.map((row) => {
            row.isEdit = false;
            if (row.patientTypeID === rowData?.patientTypeID && isEdit) {
                row.isEdit = isEdit;
                rowForEdit = row;
            }
            return row;
        });
        setTouched('');
        //    setSelectedStatus('');
        updatedFields = {};
        //  tableDataBackup = tempData;
        setTableData(tempData);
    };

    const checkvalidation = (selectedvaluesonly) => {
        debugger;
        if ((selectedvaluesonly.patientType1 == null || selectedvaluesonly.patientType1 == "" || selectedvaluesonly.patientType1 == undefined)) {
            toast.error('Patient Type Description is Required');
            return true;
        }
        else if ((selectedvaluesonly.isInPatient == undefined || selectedvaluesonly.isInPatient == null || selectedvaluesonly.isInPatient == "" || selectedvaluesonly.isInPatient == "-")) {
            toast.error('Patient Status is requied');
            return true;
        }
        // else if ((selectedvaluesonly.inactiveFlag == undefined || selectedvaluesonly.inactiveFlag == null || selectedvaluesonly.inactiveFlag == "")) {
        //     toast.error('Active  is requied');
        //     return true;

        // }
        else {
            return false;
        }
    };

    const savePanelUpdateRow = async () => {
        setIshiddenflag(false);
        toggle();
        if (checkvalidation(rowForEdit))
            return true;
        setLoading(true);
        const payload = { ...rowForEdit };
        payload.isInPatient = payload.isInPatient === "IN" ? "Y" : "N";
        delete payload.isEdit;
        try {
            const result = await API.post(
                `SBTenant/${tenantID}/Configuration/EditPatient`,
                payload,
                {
                    hasDefaultURL: true,
                },
            );
            if (result) {

                if (result.data.error) {
                    toast.error(result.data.message);
                }
                else {
                    toast.success('Patient Updated Successfully');
                }
                setLoading(false);
                fetchAccumulatorTable();
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    const updateRowValue = (value, col) => {

        const tempRow = { ...rowForEdit };
        if ((originalData.patientType1 == value && originalData.isInPatient == tempRow.isInPatient && originalData.inactiveFlag == tempRow.inactiveFlag) || (originalData.isInPatient == value && originalData.inactiveFlag == tempRow.inactiveFlag && originalData.patientType1 == tempRow.patientType1) || (originalData.inactiveFlag == value && originalData.patientType1 == tempRow.patientType1 && originalData.isInPatient == tempRow.isInPatient)) {
            setIshiddenflag(false);
            tempRow[col] = value;
            rowForEdit = tempRow;
        }
        else if (tempRow.patientType1 != value || tempRow.isInPatient != value || tempRow.inactiveFlag != value) {
            setIshiddenflag(true);
            tempRow[col] = value;
            rowForEdit = tempRow;
        }
    };
    const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
        if (formatterType == "statusList") {
            return (
                <CellEditRender
                    row={row}
                    col={col}
                    formatterType={formatterType}
                    onChange={updateRowValue}
                    hasTouched={hasTouched}
                    alwaysEditableCheckbox={alwaysEditableCheckbox}
                    listArray={PatientType}
                    requiredFields={formatterType}
                    
                />
            );
        }
        if (formatterType == "checkbox") {
            return (
                <CellEditRender
                    row={row}
                    col={col}
                    formatterType={formatterType}
                    onChange={updateRowValue}
                    alwaysEditableCheckbox={alwaysEditableCheckbox}
                />
            );
        }
        else {
            return (
                <CellEditRender
                    row={row}
                    col={col}
                    formatterType={formatterType}
                    onChange={updateRowValue}
                    alwaysEditableCheckbox={alwaysEditableCheckbox}
                    // requiredFields={formatterType}
                    requiredFields= "text"

                />
            );
        }
    };
    const handleExport = async () => {
        debugger;
        const filterObj = cloneDeep(search);
        //filterObj.ActiveButton = ActiveButton
        if (columnFilters && columnFilters.length > 0) {
          filterObj.filters = [...filterObj.filters, ...columnFilters];
        }

        const { access_token } =
            JSON.parse(localStorage.getItem('pharmaforce')) || {};

        var additionalCriteria = {};
        additionalCriteria.IsSelectedColumn = false;
        additionalCriteria.OrgId = orgId.organizationID;
        // additionalCriteria.ContractId = 0;
        // additionalCriteria.POId = 0;
        // additionalCriteria.OpaId = 0;
        // additionalCriteria.CEId = 0;
        // additionalCriteria.ManufactureId = 0;

        var payload = {};
        payload.tenantID = orgId.tenantID;
        payload.gridCode = "patientList";
        payload.fileTypeCode = "csv";
        payload.criteria = JSON.stringify(filterObj);
        payload.additionalCriteria = JSON.stringify(additionalCriteria);
        const { data } = await API.post(`export/queue`, payload, {
            hasExport: true,
        });
        //  const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${orgId.tenantID}/Reports/ExportManufacturerAlls?access_token=${access_token}`;
        //  onExport(action, initialFilters);
    };
    let mainCol = [
        {
            dataField: 'edit',
            text: 'Options',
            cellRenderer: (rowData) => cellRenderEdit(rowData),
            width: 100,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
        },

        {
            dataField: 'patientTypeCode',
            text: 'Patient Type Code',
            sort: true,
            width: 220,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.patientTypeCode),
        },
        {
            dataField: 'patientType1',
            text: 'Patient Type Description',
            sort: true,
            width: 250,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            edit: true,
            cellRenderer: (row, col) => formatter(row, col, "text"),
        },
        {
            dataField: 'isInPatient',
            text: 'Patient Status',
            sort: false,
            width: 130,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            edit: true,
            //default: 
            cellRenderer: (row, col) => formatter(row, col, "statusList"),
        },
        {
            dataField: 'inactiveFlag',
            text: 'Active',
            sort: false,
            width: 80,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            edit: true,
            cellRenderer: (rowData, col) => rowData.isEdit == true ? formatter(rowData, col, "checkbox", true) : renderCheckBox(rowData, col)
        },
        {
            dataField: 'pendingCount',
            text: 'Pending Count',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.pendingCount == 0 ? "0" : row.pendingCount),
        },
        {
            dataField: 'modifiedByID',
            text: 'Modified By',
            sort: false,
            width: 150,
            show: true,
            inputType: 'text',
            hideColFilter: false,
            cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
        },
        {
            dataField: 'modifiedDate',
            text: 'Modified Date',
            sort: true,
            width: 150,
            show: true,
            inputType: "date",
            hideColFilter: false,
            cellRenderer: (row) => dateFormate(row.modifiedDate),
        },


    ];

    const handleSort = (filter, hasColFilter) => {
        debugger
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };

    const handleSearchColumnFilters = (colFilter) => {
        debugger;
        if (onSearchColumnFilters) {
            onSearchColumnFilters(colFilter);
            setColFilters(colFilter);
            setColumnFilters(colFilter)
        }        
    };
    const handleFilterCancel = () => {
        debugger
        setColumnFilters([])
        search.filters= [];
        configPatientType.search.currentPage=1;
        configPatientType.search.isFilterCancel = true;
        fetchAccumulatorTable()
    };

    const { filters: colFilter, backUpData } = state;

    return (
        <div>


            <Row className='d-flex align-items-center'>
                <Col md={6}>
                    <h5 className="f-16 text-primary font-weight-700" style={{marginBottom:"0"}}>
                        Patient Type Count ({totalSize ? totalSize : 0})
                    </h5>
                </Col>

                <Col md={6}>
                    <div className='' style={{ float: "right" }}>
                        <Button
                            color="primary"
                            className="reset addbtn ms-3"
                            hidden={!(hasPermission('AD'))}
                            onClick={manvalPharmacy}
                        // disabled={backUpData.length==0}
                        >
                            <span className="right_5"><img src={plus} alt="" />
                            </span> Add
                        </Button>
                    </div>

                </Col>
            </Row>
            <hr />


            <div
                //     className='table-card scroll-table position-relative border-0 rounded'
                // fixed-height={tableData.length > 0 ? 'fixed-height' : 'default'}
                className="table-card scroll-table position-relative border-0 rounded pt-0"
                fixed-height={
                    backUpData.length > 0
                        ? `${collapseSider ? "collapse-fixed-height" : "fixed-height"}`
                        : "default"
                }
            >
                <ReactStrapTable
                    id='patientType-table'
                    height={550}
                    fixedColumn
                    width={1200}
                   // display={}
                    hasPagination
                    // reset={reset}
                    data={backUpData}
                    columns={mainCol}
                    filters={filters}
                    onExport={handleExport}    
                    totalRecords={totalSize}
                    pageSize={filters.pageSize}
                    currentPage={filters.currentPage}
                    toggleSider={toggleSider}
                collapseSider={collapseSider}
                 // showtoggle={true}
                    onPageSizeChange={onPageSizeChange}
                    handleSort={handleSort}
                   onPageChange={onHandlePageChange}
                    onFilterCancel={handleFilterCancel}
                    onSearchColumnFilters={handleSearchColumnFilters}
                // hasExportPermission={hasExportPermission}
                />
            </div>
            <div>
                <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader className="modal-header-primary" toggle={toggle}>Patient Type Change</ModalHeader>
                    <ModalBody className="custom-modal-body">
                        {rowForEdit.inactiveFlag == 'N' ? (
                            <p> This change will be applied both historically and going forward. Affected records will be reprocessed.
                                {/* <a href="mailto:support@thepharmaforce.com" class="custom-link">support@thepharmaforce.com</a>. */}
                            </p>
                        ) : (
                            <p> This change will be effective going forward, to reprocess charges in the past please submit a ticket to{' '}
                                <a href="mailto:support@thepharmaforce.com" class="custom-link">support@thepharmaforce.com</a>.
                            </p>
                        )}
                        <div className="modal-buttons">
                            <Button color="primary" className='search' onClick={savePanelUpdateRow}> <span className="right_5">
                                <img src={save} alt="" />
                            </span> OK</Button>
                            <Button color="primary" className='reset' onClick={toggle}> <span className="right_5">
                                <img src={cancel} alt="" />
                            </span> Cancel</Button>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        </div>
    );
};

export default PatientTypeTable
